import { REGEX_URL } from "../../../../utils/regex";
import {
  FIELD_REQUIRED,
  FIELD_URL_VALID,
  SECTION_ADDITIONAL_ASSETS_MAX_ERROR,
  SECTION_ADDITIONAL_ASSETS_INCOMPLETE_PAIR,
} from "../../../../i18n/keysTranslations";
import { MAX_ADDITIONAL_ASSETS } from "./formDataTransformers";
import i18next from "i18next";

export const getValidationRules = (t = i18next.t.bind(i18next)) => ({
  websiteUrl: {
    validate: (value) => {
      if (value && !REGEX_URL.test(encodeURI(value))) {
        return t(FIELD_URL_VALID);
      }
    },
  },
  businessName: {
    required: {
      value: true,
      message: t(FIELD_REQUIRED),
    },
  },
  businessDescription: {
    required: {
      value: true,
      message: t(FIELD_REQUIRED),
    },
  },
  businessTextStyle: {
    required: {
      value: true,
      message: t(FIELD_REQUIRED),
    },
  },
  businessLookAndFeel: {
    required: {
      value: true,
      message: t(FIELD_REQUIRED),
    },
  },
  businessValueProposition: {
    required: {
      value: true,
      message: t(FIELD_REQUIRED),
    },
  },
  businessIdealCustomerProfile: {
    required: false,
  },
  businessOffering: {
    required: {
      value: true,
      message: t(FIELD_REQUIRED),
    },
  },
  businessBuyerPerson: {
    required: false,
  },
  businessCompetitors: {
    required: false,
  },
  socialNetworks: {
    required: false,
  },
  logoUrl: {
    required: false,
  },
  businessProductImages: {
    required: false,
  },
  additionalAssets: {
    required: false,
    validate: (items) => {
      if (!Array.isArray(items) || items.length === 0) return true;
      if (items.length > MAX_ADDITIONAL_ASSETS) {
        return t(SECTION_ADDITIONAL_ASSETS_MAX_ERROR);
      }
      for (const item of items) {
        const hasImage = !!item?.urlImage?.trim();
        const hasPrompt = !!item?.prompt?.trim();
        if (hasImage !== hasPrompt) {
          return t(SECTION_ADDITIONAL_ASSETS_INCOMPLETE_PAIR);
        }
      }
      return true;
    },
  },
  businessCountry: {
    required: false,
  },
  businessColors: {
    validate: (value) => {
      if (!Array.isArray(value) || value.length < 1) {
        return t(FIELD_REQUIRED);
      }
    },
  },
  businessTypography: {
    required: false,
  },
  businessTypographyPreview: {
    required: false,
  },
});
